import Widget from '@/plugins/dashboard/widgets/Pickups/Widget'
import Configure from '@/plugins/dashboard/widgets/Pickups/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Pickups'
  static widget = Widget
  static configure = Configure
}
